import { client } from '../http';

async function fetchPapasQuestions() {
  const response = await client.get('/api/investigator/questions/merge/papas');
  return response.data;
}

async function fetchSonsQuestions() {
  const response = await client.get('/api/investigator/questions/merge/sons');
  return response.data;
}

async function answerPapaQuestion({ transactionId, input }) {
  return await client.post('/api/investigator/answers/merge', {
    papasMergeInput: [{ transactionId, input }],
  });
}

async function answerSonQuestion({ chunkId, input, account }) {
  return await client.post('/api/investigator/answers/merge', {
    sonsMergeInput: [{ chunkId, input, account }],
  });
}

async function answerMultipleQuestions(papasMergeInput, sonsMergeInput) {
  return await client.post('/api/investigator/answers/merge', { papasMergeInput, sonsMergeInput });
}

export default {
  fetchPapasQuestions,
  fetchSonsQuestions,
  answerPapaQuestion,
  answerSonQuestion,
  answerMultipleQuestions,
};



// WEBPACK FOOTER //
// ./src/api/MergeInvestigatorApi.js